import { AccountDetails } from 'clientServerShared/types/account';
import { AppProviders } from 'projects/legacyClient/src/appProviders';
import { FC } from 'react';
import { HeapCategory } from 'clientServerShared/types/eventTracking';
import { LegacyBreedSummaryCard } from '@embark/shared-components/src/breedSummary/legacyBreedSummaryCard';
import { LegacyBreedSummaryCardFragment } from '@embark/shared-components/src/generated/graphql-client-types';
import ReactDOM from 'react-dom';
import { useAppSelector } from 'projects/legacyClient/src/react/state/hooks';

export function initPublicProfileBreedSummaryCard(): void {
  ReactDOM.render(
    <AppProviders>
      <PublicProfileBreedSummaryCardContainer />
    </AppProviders>,
    document.getElementById('public-profile-breed-summary-card')
  );
}

const PublicProfileBreedSummaryCardContainer: FC = () => {
  const data: LegacyBreedSummaryCardFragment = window['reactPet'];

  const accountDetails: AccountDetails | undefined = useAppSelector((state) => state.accountDetails);

  return (
    <LegacyBreedSummaryCard
      accountDetails={accountDetails}
      dog={data}
      showShare={false}
      showProductType={false}
      showCareResourcesBanner={false}
      heapMetadata={{ heapCategory: HeapCategory.RESULTS_BREED }}
    />
  );
};
